module.exports = __webpack_public_path__ + "img/ic_h5_vip2.b0ed2c65.png";